import { render, staticRenderFns } from "./CardReporteCoordinador.vue?vue&type=template&id=f361fcaa&scoped=true"
import script from "./CardReporteCoordinador.vue?vue&type=script&lang=js"
export * from "./CardReporteCoordinador.vue?vue&type=script&lang=js"
import style0 from "./CardReporteCoordinador.vue?vue&type=style&index=0&id=f361fcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f361fcaa",
  null
  
)

export default component.exports